import * as React from 'react';
import './App.css';
import NavMain from './Components/NavMain';
import Footer from './Components/Footer';
import Logo from './Assets/media/Logo.png';
import { 
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBContainer,
  MDBIcon} from 'mdb-react-ui-kit';
import { Link } from "react-router-dom";

function App() {

  return (
    <MDBContainer fluid className='text-center'>
      <MDBContainer fluid className='mx-0'>
        <MDBRow>
          <MDBCol className='d-flex justify-content-end m-3'>
              <MDBBtn outline color="white" floating className='bgOverlay m-1' size='mdS' href='*' role='button'>
                <MDBIcon fas icon='user-alt' />
              </MDBBtn>
          </MDBCol>       
        </MDBRow>
        <MDBRow between className='d-flex justify-content-start'>
          <MDBCol>
            <NavMain />  
          </MDBCol>
        </MDBRow>         
          <div className=' text-black pt-5'>
            <img className='m-0' src={Logo} alt='Societal Labs Logo' style={{width: '225px'}}/>
            <p className='title mx-auto'>Societal Labs</p>
            <p className='opener mx-auto fs-4'>Home of h.Society</p> 
          </div>
          <div className='d-flex justify-content-center text-center py-5'>
            <MDBBtn className='bgOverlay mx-auto' size='lg'>
                <Link to='/mint' className='text-decoration-none text-white'>Mint h.Society NFTs</Link>
            </MDBBtn>
          </div>
        <Footer />
      </MDBContainer>
    </MDBContainer>
  );
}

export default App;
